// extracted by mini-css-extract-plugin
module.exports = {"modal":"Servicio_modal__2cF9-","texto":"Servicio_texto__1-RgM","btn":"Servicio_btn__1BIBs"};